import React from 'react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

import { bemBlock } from '../../modules/bem';
import { GlyphName, Icon } from '../icon/Icon';

import { useEmblemContext } from './EmblemContext';
import { EmblemSize } from './types';

import './EmblemIcon.less';

type EmblemIconProps = {
  glyph: GlyphName;
};

const block = bemBlock('emblem-icon');

export const EmblemIcon: React.FC<EmblemIconProps> = ({ glyph }) => {
  const { size } = useEmblemContext();

  const iconSizeByEmblemSize: Record<EmblemSize, SizeProp> = {
    xs: 'xs',
    sm: 'sm',
    md: '1x',
    lg: 'lg',
  };

  return <Icon glyph={glyph} size={iconSizeByEmblemSize[size]} className={block()} />;
};
